import { Contract, ContractType } from 'cpes-common';
import { PostboxDocumentType } from '../helper/DocumentType';

const financingDocumentTypes: PostboxDocumentType[] = [
    'FINANCING_CONTRACT', // 25
    'LONG_DRIVE_SERVICE_CONTRACT', // 26
    'CARDIF_INSURANCE_POLICY', // 28
    'SEPA_MANDATE', // 32
    'CONSUMER_CREDIT_INFORMATION', // 35
    'WELCOME_LETTER', // 45
];

export const documentTypesByContractType: Record<ContractType, PostboxDocumentType[]> = {
    [ContractType.FINANCING]: financingDocumentTypes,
    [ContractType.FINANCE_LEASE]: ['LEASING_INVOICE', ...financingDocumentTypes], // 636 + financing
    [ContractType.OPERATING_LEASE]: [
        'INVOICE', // 146
        'BILLING_REPORT', // 626
        'PARTICULAR_CONDITIONS', // 27
        'MASTER_AGREEMENT', // 84
        'SEPA_MANDATE', // 32
    ],
};

export const getDocumentTypeOptionsForContracts = (
    options: PostboxDocumentType[],
    contracts: Contract[],
    contractNumber: string,
): PostboxDocumentType[] => {
    const selectedContracts =
        contractNumber === 'ALL' ? contracts : contracts.filter(contract => contract.contractNumber === contractNumber);
    const availableTypes = new Set(
        selectedContracts.flatMap(contract => documentTypesByContractType[contract.contractType] ?? []),
    );
    return options.filter(option => availableTypes.has(option));
};
